// File: src/components/common/AdBanner.js

import React, { useEffect } from 'react';

const AdBanner = ({ dataAdSlot, dataAdFormat, style }) => {
    useEffect(() => {
        try {
            if (window.adsbygoogle) {
                // Timeout to ensure DOM is ready
                setTimeout(() => {
                    (window.adsbygoogle = window.adsbygoogle || []).push({});
                }, 100);
            }
        } catch (e) {
            console.error("AdSense Error:", e);
        }
    }, [dataAdSlot]);

    return (
        <div style={{ margin: "20px 0", textAlign: "center", width: "100%", ...style }}>
            <p style={{ fontSize: "10px", color: "#ccc", margin: "0 0 5px 0" }}>Advertisement</p>
            <ins
                className="adsbygoogle"
                style={{ display: 'block' }}
                data-ad-client="ca-pub-5893406488195912"
                data-ad-slot={dataAdSlot}
                // Agar format nahi diya toh default 'auto' lega, warna jo pass karoge wo lega
                data-ad-format={dataAdFormat || "auto"} 
                data-full-width-responsive="true"
            ></ins>
        </div>
    );
};

export default AdBanner;